import React from 'react';
import { Text } from 'v3/components';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { styles } from '../styles';

export default function CertificatePreview({
  certificateUrl,
  handleDownloadCertificate,
  isMobile,
}) {
  const hasCertificateUrl = !!certificateUrl;

  return (
    <div style={styles.certificatePreviewCard(isMobile)}>
      <div style={styles.certificatePreviewHeader(isMobile)}>
        <div style={styles.certificatePreviewTitleWrap}>
          <CheckCircleOutlineIcon style={{ fontSize: 28, color: '#059669' }} />
          <div>
            <Text
              type="header"
              color="dark"
              style={styles.certificatePreviewTitle}
              weight={600}
            >
              Treinamento concluído com sucesso!
            </Text><br/>
            <Text color="gray" style={styles.certificatePreviewSubtitle}>
              Seu certificado foi enviado para o e-mail cadastrado e já está disponível para download.
            </Text>
          </div>
        </div>

        <div style={styles.certificatePreviewActions(isMobile)}>
          <button
            type="button"
            disabled={!hasCertificateUrl}
            onClick={handleDownloadCertificate}
            title={
              hasCertificateUrl
                ? 'Baixar certificado'
                : 'Certificado enviado por e-mail, mas o link de download não foi retornado pela API.'
            }
            style={styles.certificateDownloadButton(
              isMobile,
              !hasCertificateUrl
            )}
          >
            <FileDownloadOutlinedIcon style={{ fontSize: 18 }} />
            <span>Baixar certificado</span>
          </button>
        </div>
      </div>
    </div>
  );
}
